import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EditorConfig } from '@fleet-beat/editor';
import { FormDialogOptions } from '@fleet-beat/shared';

@Component({
  selector: 'fb-form-dialog',
  templateUrl: './form-dialog-container.component.html',
  styleUrls: ['./form-dialog-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDialogContainerComponent {
  options: FormDialogOptions;
  form: FormGroup;
  config: EditorConfig;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: FormDialogOptions,
    private dialogRef: MatDialogRef<FormDialogContainerComponent>,
  ) {
    this.options = data;
    this.form = data.form;
    this.config = data.config;
  }
  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close(this.form?.value);
  }
}
